/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// utils
import { generateClasses } from 'utils/generators';
// material
import Link from 'material/ctas/link/link_container';
import Tip from 'material/message/tip/tip';
import Icon from 'material/graphic/icon/icon';
import Loader from 'material/loader/loader';
// charts
import OverviewLineChart from 'material/chart/linechart/overview/overview';
import DetailLineChart from 'material/chart/linechart/detail/detail';
import NoDataView from 'material/nodataview/nodataview';
// styles
import injectSheet from 'react-jss';
import styles from 'material/chart/linechart/linechart_styles';




/* ========== ~~~~~~~~~~ CHART : LINE : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class LineChart extends Component {
	// make sure parent container have a defined height when using responsive component, otherwise height will be 0 and no chart will be rendered.
	handleChartVariant = () => {
		switch (this.props.variant) {
			case 'detail':
				return <DetailLineChart metricType={this.props.metricType} data={this.props.data} />;
			case 'overview':
			default:
				return <OverviewLineChart metricType={this.props.metricType} data={this.props.data} />;
		}
	};
	handleLoadVariant = () => {
		switch (this.props.loading) {
			case true:
				return null;
			default:
				return <NoDataView/>;
        }
	};
	handleNoData = () => this.props.data && this.props.data.length ? this.handleChartVariant() : this.handleLoadVariant();
	hasText = () => {
		return this.props.label || this.props.value ? true : false;
	};
	hasToolTip = () => {
		return this.props.tooltip ? true : false;
	};
	handleClick = (e) => {
		return this.props.dataType ? this.props.moveToPage(`dashboard/analytics/detail/${this.props.dataType}`) : null;
	};
	render() {
		return (
	        <div className={`chart linechart ${generateClasses(this.props)} ${this.props.classes.linechart} hasDetails-${this.props.moreDetails ? this.props.moreDetails : false}`} onClick={this.handleClick}>
	        	<div className={`data`}>
	        		{this.hasText() || this.hasToolTip() ? 
			        	<div className={`info`}>
			        		<div className={`text`}>
				        		<div className={`label`}>{this.props.label}</div>
								<div className={this.props.loading ? `loading` : `value`}>{this.props.loading ? <div className={`loading`} >Loading...<Loader name={'loader'}/></div> : this.props.value}</div>
				        	</div>
							{this.hasToolTip() ? <Tip content={this.props.tooltip} /> : null}
			        	</div>
			        	:
			        	null
			        }
			        <div className={`visualization`}>
                    	{this.handleNoData()}
                    </div>
		        </div>
		        {!this.props.moreDetails ? null :
		        	<div className={`details`}>
		        		<Link type={`internal`} text={`View Details`} color={`primary`} action={`dashboard/analytics/detail/${this.props.dataType}`} icon={<Icon name={`external-link-alt`} />} iconRight />
		        	</div>
		        }
	        </div>
		);
	}
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(LineChart);